export function replaceToken(haystack: string, needle: string, tokens: { [key: string]: any }): string {
  const token = needle.replace(/\{|\}/g, '');
  const value = tokens[token];

  if (value === undefined) {
    return haystack;
  }

  return haystack.replace(needle, value);
}

export function parseTokens(haystack: string, tokens: { [key: string]: any }): string {
  const needles = haystack.match(/\{.*?\}/g) ?? [];

  needles.forEach((needle: string) => {
    haystack = replaceToken(haystack, needle, tokens);
  });

  return haystack;
}
